import { inviteUrl } from 'utils/common';

export const REFERRAL_ID_QUERY_STRING_PARAMETER = 'ri';
export const PLAYER_FIRST_NAME_FALLBACK = 'Someone';
export const PLAYER_FIRST_NAME_ALT_FALLBACK = 'your friend';
